import { render, staticRenderFns } from "./ShippingLable.vue?vue&type=template&id=15723288&"
import script from "./ShippingLable.vue?vue&type=script&lang=js&"
export * from "./ShippingLable.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLable.vue?vue&type=style&index=0&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
